import weui from 'weui.js';
import { uniqid, sleep } from '@/utils';

function alert(content = '', options = {}) {
    return new Promise((resolve) => {
        weui.alert(content,
            () => resolve(true),
            options);
    });
}

function confirm(message, title = null) {
    return new Promise((resolve) => {
        weui.confirm(message,
            () => resolve(true),
            () => resolve(false),
            { title });
    });
}

function dialog({ title, content, className, buttons }) {
    return new Promise((resolve) => {
        const buttons2 = Array.isArray(buttons) ? buttons : [{
            label: '确定',
            type: 'primary',
            value: true,
        }];
        const options = {
            title: title !== undefined ? title : null,
            content: content !== undefined ? content : '',
            className: className !== undefined ? undefined : '',
            buttons: buttons2.map(btn => ({
                label: btn.label,
                type: btn.type || 'default',
                onClick: () => resolve(btn.value || false),
            })),
        };

        weui.dialog(options);
    });
}

function picker(items, options = {}) {
    return new Promise((resolve) => {
        weui.picker(items, {
            id: uniqid(),
            onConfirm: result => resolve(result),
            onClose: () => resolve(false),
            ...options,
        });
    });
}

function toast(content, options = {}) {
    weui.toast(content, options);
    return sleep(500);
}

export default {
    alert,
    confirm,
    dialog,
    picker,
    toast,
};



// WEBPACK FOOTER //
// ./src/wechat/weui.js